const customJoin = {}

function joinFields (obj, separator = ', ') {
  if (obj) {
    const fieldValues = Object.values(obj)
    const fieldValues2 = fieldValues.filter(o => o)
    if (Array.isArray(fieldValues2) && fieldValues2.length === 1) {
      return fieldValues2[0]
    }
    return fieldValues2.join(separator)
  }
  return ''
}

customJoin.install = function (Vue) {
  Vue.filter('join-fields', (value, field) => {
    return joinFields(value, field)
  })
}

export default customJoin
